import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import axios from '../../../../data/http/axios'
import Icons from '~/Common-Objects/UI/Icons/index'
import Indicator from '~/Common-Objects/UI/Indicator/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import FormatNumberFuncs from '../../../../Classes/numberFormatFunctions'

export default function SiteVisitsPanel({ edit }) {
    const [stats, setStats] = useState(null)
    const siteMaster = useSelector(state => state.siteMaster)

    const getStats = async () => {
        const res = await axios.get('/accountMaster/tracker/stats')
        setStats(res.data)
    }

    useEffect(() => {
        getStats()
    }, [])

    let increase = false
    let diff = 0
    if (stats) {
        increase = stats[0] > stats[1]
        diff = increase
            ? Math.round((stats[0] / stats[1]) * 100) - 100
            : 100 - (Math.round((100 / stats[1]) * stats[0]))
    }
    const color = increase ? siteMaster.colours["$status-green"] : siteMaster.colours["$status-red"]

    return <Paper className="m-mar-b0" iconRight={<Icons icon="pencil" color="grey" />} iconRightClick={edit}>

        <h4 className="mar-b20">Site Visits</h4>
        <div>
            {!stats && <LoadingIcons />}
            {!!stats && <>
                <div className="quickFlex mar-b10">
                    <h4 className="mar-r16 statistic">{FormatNumberFuncs.formatNumber(stats[0])}</h4>
                    {!isNaN(diff) && <Indicator leftIcon={<Icons icon={increase ? "arrowUp" : "arrowDown"} color={color} />} className={increase ? "indicator-green" : "indicator-red"}>{diff}%</Indicator>}
                    {isNaN(diff) && <Indicator className="indicator-grey">0.00%</Indicator>}
                </div>
                <div>people visited your sites this month</div>
            </>}
        </div>


    </Paper>
}